import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
const Faq = () => {
  return (
    <div className="teams mt-5" id="faq">
      <div className="faqs">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading">
                <h4>Frequently Asked Questions</h4>
                <p>
                  If you can't find your question here, please feel free to
                  &nbsp; <Link to="">contact us.</Link>
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8 offset-lg-2 pt-5 pt-lg-0">
              <Accordion className="faq-accordion row">
                <div className="col-lg-12">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>What is TRIBE?</Accordion.Header>
                    <Accordion.Body>
                      A: TRIBE is an AI-powered super app that integrates chat,
                      video sharing, shopping, and payments into one seamless
                      platform, designed to eliminate app fatigue and enhance
                      user experience.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      What makes TRIBE unique?
                    </Accordion.Header>
                    <Accordion.Body>
                      A: TRIBE leverages AI and machine learning to deliver
                      personalized, secure, and efficient digital interactions,
                      setting it apart from traditional fragmented apps.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="2">
                    <Accordion.Header>
                      What is the TRIBE token?
                    </Accordion.Header>
                    <Accordion.Body>
                      A: The TRIBE token is the native utility token of the
                      TRIBE ecosystem, used for in-app transactions, premium
                      features, staking, and rewards.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="5">
                    <Accordion.Header>
                      How can I participate in the TRIBE ICO?
                    </Accordion.Header>
                    <Accordion.Body>
                      A: You can participate in the TRIBE ICO by purchasing
                      TRIBE tokens during the pre-sale or public sale using
                      supported cryptocurrencies or payment methods.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="7">
                    <Accordion.Header>
                      What is the total supply of TRIBE tokens?
                    </Accordion.Header>
                    <Accordion.Body>
                      A: The total supply of TRIBE tokens is 100 billion, with
                      allocations for development, community rewards, staking,
                      and ecosystem growth.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="8">
                    <Accordion.Header>What is TRIBE staking?</Accordion.Header>
                    <Accordion.Body>
                      A: TRIBE staking allows users to lock their tokens to earn
                      rewards, support network security, and participate in the
                      ecosystem’s growth.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="9">
                    <Accordion.Header>
                      What are the benefits of staking TRIBE?
                    </Accordion.Header>
                    <Accordion.Body>
                      A: Staking TRIBE tokens provides rewards, voting rights in
                      governance decisions, and contributes to the stability and
                      growth of the TRIBE ecosystem.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
                <div className="col-lg-12">
                  <Accordion.Item eventKey="10">
                    <Accordion.Header>
                      How do I stake TRIBE tokens?
                    </Accordion.Header>
                    <Accordion.Body>
                      A: Staking will be available through the TRIBE app once
                      the feature is live. Users can lock their tokens and start
                      earning rewards.
                    </Accordion.Body>
                  </Accordion.Item>
                </div>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
